import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { CartProvider } from "@/context/CartContext";
import { Header } from "@/components/Header";
import { CartDrawer } from "@/components/CartDrawer";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import ShopPage from "@/pages/ShopPage";
import { PaymentSuccess, PaymentCancel } from "@/pages/PaymentResult";
import TermsPage from "@/pages/TermsPage";
import TrackOrder from "@/pages/TrackOrder";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const ScrollManager = () => {
    const location = useLocation();
    useEffect(() => {
        if (location.hash) {
            setTimeout(() => {
                document.querySelector(location.hash)?.scrollIntoView({ behavior: "smooth" });
            }, 400);
        } else {
            window.scrollTo(0, 0);
        }
    }, [location]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="App grain-overlay">
            <CartProvider>
                <BrowserRouter>
                    <ScrollManager />
                    <Header />
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/shop" element={<ShopPage />} />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                        <Route path="/payment/cancel" element={<PaymentCancel />} />
                        <Route path="/terms" element={<TermsPage />} />
                        <Route path="/track" element={<TrackOrder />} />
                        <Route path="/admin" element={<AdminDashboard />} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                    </Routes>
                    <CartDrawer />
                </BrowserRouter>
                <Toaster theme="dark" position="bottom-right" />
            </CartProvider>
        </div>
    );
}

export default App;
